import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

interface LoadingProps {
  size?: number | string;
  color?: string;
}

const Loading: React.FC<LoadingProps> = ({
  size = "1em",
  color = "primary",
}) => {
  return (
    <CircularProgress style={{ width: size, height: size, color: color }} />
  );
};

export default Loading;
